import './event.less'
import m from 'mithril'
import {t} from 'store'
import {Component, action, Icon} from '@codeurs/front'
import EventImage from './eventimage'
import Link from 'views/layout/link'
import Arrow from 'assets/icons/arrow.svg'
import {getTagCodes} from 'util/tags'
import TagLink from 'views/layout/taglink'

export type EventType = {
	url: string
	start_date: Date
	title: string
	tags?: Array<string>
	policy?: Array<string>
	sector?: Array<string>
}
export default class Event extends Component<{
	event: EventType
	lists: any
}> {
	view() {
		const {start_date, title, url} = this.attrs.event
		return (
			start_date &&
			m('.event', [
				start_date &&
					m('.event-left', {...action(url)}, m(EventImage, {start_date})),
				m('.event-right', [
					title && m('a.event-right-title', {...action(url)}, title),
					this.tagsView(),
					m(Link,
						{
							mod: 'blue',
							class: 'event-right-link',
							...action(url)
						},
						[
							m('.event-right-link-text', t('events.moreinfo')),
							m('.event-right-link-arrow', '>')
						]
					)
				]),
				m('a',
					action(url),
					m(Icon, {icon: 'arrow', class: 'event-right-arrow'})
				)
			])
		)
	}
	tagsView() {
		const {tags, policy, sector} = this.attrs.event
		const {
			lists: {policies, sectors, tags: tagList}
		} = this.attrs
		const map = (collection, extract) =>
			(collection && collection.map(extract)) || []
		return m('.event-right-tags',
			map(policy, p => policies[getTagCodes(p, 'd')].name)
				.concat(map(sector, s => sectors[getTagCodes(s, 'k')]))
				.concat(map(tags, t => tagList[t]))
				.slice(0, 2)
				.map(tag =>
					m(TagLink, {mod: 'tag', class: 'event-right-tags-tag', text: tag})
				)
		)
	}
}
